export const tableOperationsFields = {
  date: 'date',
  fullNameParent: 'parentName',
  amountPaid: 'amountPaid',
  projectName: 'projectName',
  paymentDescription: 'paymentDescription',
  cardNumbers: 'cardNumbers'
}
